.curve {
  stroke-width: 3.8px;
  &[stroke-dashoffset='0'] {
    stroke-width: 1px;
    stroke: var(--mantine-color-gray-2);
  }
}
